import React from "react";

const OptionalSegmentVisibility = ({
  visible,
  segmentId,
  onChange,
  compact = true,
}) => {
  const handleVisible = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!visible) onChange(segmentId, true);
  };

  const handleHidden = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (visible) onChange(segmentId, false);
  };

  return (
    <div
      className={`explorer-visibility-select${compact ? " compact" : ""}`}
      role="group"
      aria-label="Optional segment visibility"
    >
      <button
        type="button"
        className={`explorer-visibility-option visible${
          visible ? " active" : ""
        }`}
        onClick={handleVisible}
        aria-pressed={visible}
      >
        Visible
      </button>
      <button
        type="button"
        className={`explorer-visibility-option hidden${
          !visible ? " active" : ""
        }`}
        onClick={handleHidden}
        aria-pressed={!visible}
      >
        Hidden
      </button>
    </div>
  );
};

export default OptionalSegmentVisibility;
